<template>
  <div class="text-left mb-15">
    <div class="delivery-address">
      <el-form
        ref="userDetailsUpdate"
        :model="addressDetail"
        :rules="addressRules"
        v-if="reReneder"
      >
        <el-row class="mt-10">
          <h5 class="shipping-billing-profile">{{ $t("users.deliveryAddress.billingAddress") }}</h5>
        </el-row>
        <el-row>
          <el-col :xs="12" :sm="23" :md="12">
            <el-form-item prop="rue" class=" mb-0">
              <el-input
                class="userDetail-input"
                v-model="addressDetail.rue"
                :placeholder="$t('users.deliveryAddress.rue')"
              />
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-col :xs="12" :sm="6" :md="6">
            <el-form-item prop="ville" class="mb-0">
              <el-input
                class="userDetail-input"
                v-model="addressDetail.ville"
                :placeholder="$t('users.deliveryAddress.ville')"
              />
            </el-form-item>
          </el-col>
        </el-row>
        <el-row :gutter="10">
          <el-col :xs="24" :sm="6" :md="6">
            <el-form-item prop="province">
              <el-input
                class="userDetail-input"
                v-model="getCountryCode"
                :placeholder="$t('users.deliveryAddress.ville')"
                disabled
              />
              <!-- <el-select
                v-model="addressDetail.province"
                :placeholder="$t('users.deliveryAddress.province')"
              >
                <el-option
                  v-for="province in provinces"
                  :key="province.id"
                  :label="province.name"
                  :value="province.id"
                >
                </el-option>
              </el-select> -->
            </el-form-item>
          </el-col>
          <el-col :xs="24" :sm="6" :md="6">
            <el-form-item prop="codePostal">
              <el-input
                class="userDetail-input"
                v-model="addressDetail.codePostal"
                :placeholder="$t('users.deliveryAddress.codePostal')"
              />
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-col :xs="12" :sm="6" :md="6">
            <el-checkbox
              v-model="addressDetail.copyAddress"
              @change="setSameAddress()"
            >
              {{ $t("users.deliveryAddress.copyAddress") }}
            </el-checkbox>
          </el-col>
        </el-row>
        <div v-if="showDeliveryAddress">
          <el-row class="mt-10">
            <h5>{{ $t("users.deliveryAddress.deliveryAddress") }}</h5>
          </el-row>
          <el-row>
            <el-col :xs="12" :sm="23" :md="12">
              <el-form-item prop="rue2" class="mb-0">
                <el-input
                  class="userDetail-input"
                  v-model="addressDetail.rue2"
                  :placeholder="$t('users.deliveryAddress.rue')"
                />
              </el-form-item>
            </el-col>
          </el-row>
          <el-row>
            <el-col :xs="12" :sm="6" :md="6">
              <el-form-item prop="ville" class="mb-0">
                <el-input
                  class="userDetail-input"
                  v-model="addressDetail.ville2"
                  :placeholder="$t('users.deliveryAddress.ville')"
                />
              </el-form-item>
            </el-col>
          </el-row>
          <el-row :gutter="10">
            <el-col :xs="12" :sm="6" :md="6">
              <el-form-item prop="province2">
                <el-input
                class="userDetail-input"
                v-model="getCountryCode"
                :placeholder="$t('users.deliveryAddress.ville')"
                disabled
              />
                <!-- <el-select
                  v-model="addressDetail.province2"
                  :placeholder="$t('users.deliveryAddress.province')"
                >
                  <el-option
                    v-for="province in provinces"
                    :key="province.id"
                    :label="province.name"
                    :value="province.id"
                  >
                  </el-option>
                </el-select> -->
              </el-form-item>
            </el-col>
            <el-col :xs="6" :sm="6" :md="6">
              <el-form-item prop="codePostal">
                <el-input
                  class="userDetail-input"
                  v-model="addressDetail.codePostal2"
                  :placeholder="$t('users.deliveryAddress.codePostal')"
                />
              </el-form-item>
            </el-col>
          </el-row>
        </div>
        <el-row class="text-left mt-15">
          <el-button
            type="primary"
            native-type="submit"
            class="ctaSubmit"
            @click="updateUserDetails"
          >
            {{ $t("users.label.record") }}
          </el-button>
        </el-row>
      </el-form>
    </div>
  </div>
</template>
<script>
import { mapState } from "vuex";
import userApi from "@/api/user";
export default {
  components: {},
  props: {
    ctaSubmitText: {
      type: String,
      default: () => this.$i18n.t("products.filters.button.cancel"),
    },
    shippingAddress: {
      type: Object,
      default: () => {},
    },
    billingAddress: {
      type: Object,
      default: () => {},
    },
    countries: {
      default: () => [],
    },
    checkOut: {
      default: () => false,
    },
  },
  data() {
    return {
      addressDetail: {
        rue: this.billingAddress.street,
        ville: this.billingAddress.city,
        // province: localStorage.getItem('countryCode'),
        codePostal: this.billingAddress.postalCode,
        copyAddress: true,
        rue2: this.shippingAddress.street,
        ville2: this.shippingAddress.city,
        province2: this.shippingAddress.state.id,
        codePostal2: this.shippingAddress.postalCode,
      },
      options: [],
      value: "",
      addressRules: {
        rue: [
          {
            required: true,
            message: "Votre rue est obligatoire",
            trigger: "blur",
          },
        ],
        ville: [
          {
            required: true,
            message: "Votre ville est obligatoire",
            trigger: "blur",
          },
        ],
        // province: [
        //   {
        //     required: true,
        //     message: "Votre province est obligatoire",
        //     trigger: "blur",
        //   },
        // ],
        codePostal: [
          {
            required: true,
            message: "Votre Code Postal est obligatoire",
            trigger: "blur",
          },
        ],
        rue2: [
          {
            required: true,
            message: "Votre rue est obligatoire",
            trigger: "blur",
          },
        ],
      },
      showDeliveryAddress: false,
      defaultCountries: {
        name: "Canada",
        id: "1",
      },
      reReneder: true,
    };
  },
  watch: {
    toggleResetFields() {
      this.resetFields();
    },
  },
  computed: {
    ...mapState("user", ["user"]),
    ...mapState("configuration", ["actionBar"]),
    getCountryCode() {
      if (this.$i18n.locale == "en-US") {
        const countryCode = this.actionBar.country == 'ON' ? 'Ontario' : 'Quebec'
        return countryCode
      } 
      return this.actionBar.country == 'ON' ? 'Ontario' : 'Québec'
    },
  },
  created() {},
  methods: {
    resetFields() {
      this.$refs.registerForm.resetFields();
    },
    setSameAddress() {
      this.showDeliveryAddress =
        this.addressDetail.copyAddress == false ? true : false;
    },
    updateUserDetails(e) {
      e.preventDefault();
      const vm = this;
      this.$refs.userDetailsUpdate.validate().then((valid) => {
        if (valid) {
          var billingAddress = {
            street: this.addressDetail.rue,
            city: this.addressDetail.ville,
            state: {
              id: this.actionBar.country == 'ON' ? 2 : 1,
            },
            country: {
              id: this.defaultCountries.id,
            },
            postalCode: this.addressDetail.codePostal,
          };
          var shippingAddress = {
            street: this.addressDetail.rue2,
            city: this.addressDetail.ville2,
            state: {
              id: this.actionBar.country == 'ON' ? 2 : 1,
            },
            country: {
              id: this.defaultCountries.id,
            },
            postalCode: this.addressDetail.codePostal2,
          };
          if (this.showDeliveryAddress == false) {
            shippingAddress = billingAddress;
          }

          userApi
            .updateUser(this.user.id, {
              // .updateCustomerDetails(this.user.customer.id, {
              firstName: this.user.firstName,
              lastName: this.user.lastName,
              email: this.user.email,
              billingAddress: billingAddress,
              shippingAddress: shippingAddress,
            })
            .then((data) => {
              if (data) {
                if (this.checkOut) {
                  this.$emit("emit-update-details");
                } else {
                  this.$emit("emit-address-update");
                }
              } else {
                vm.$emit("error", "cannot authenticate user");
              }
            })
            .catch((error) => {
              vm.$emit("error", error);
            });
        }
      });
    },
    reRenderForm() {
      this.reRender = false;
      this.$nextTick(() => {
        this.reRender = true;
      });
    },
  },
  mounted() {
    this.$root.$on("chanLang", () => {
      this.reRenderForm();
      this.addressRules = {
        rue: [
          {
            required: true,
            message: this.$i18n.t("users.deliveryAddress.formRequiredMsg.rue"),
            trigger: "blur",
          },
        ],
        ville: [
          {
            required: true,
            message: this.$i18n.t(
              "users.deliveryAddress.formRequiredMsg.ville"
            ),
            trigger: "blur",
          },
        ],
        province: [
          {
            required: true,
            message: this.$i18n.t(
              "users.deliveryAddress.formRequiredMsg.province"
            ),
            trigger: "blur",
          },
        ],
        codePostal: [
          {
            required: true,
            message: this.$i18n.t(
              "users.deliveryAddress.formRequiredMsg.codePostal"
            ),
            trigger: "blur",
          },
        ],
        rue2: [
          {
            required: true,
            message: this.$i18n.t("users.deliveryAddress.formRequiredMsg.rue2"),
            trigger: "blur",
          },
        ],
      };
    });
  },
};
</script>

<style scoped>
.delivery-address .el-select {
  border: 1px solid #dcdfe6;
  display: block;
}
.ctaSubmit {
  width: 150px;
  height: 40px;
}
.password-icon-class-register {
  cursor: pointer;
  width: 20px;
  margin-right: 10px;
}
.register-input .el-input__inner {
  margin: 0px !important;
}
.shipping-billing-profile {
  font-size: 18px;
}
</style>
